import { SalesOrdersAccessTableRow } from '@zspace/types';
import {
  SALES_ORDERS_FOR_ACCESS_STORAGE_KEY,
  SessionStorageServiceImpl,
} from '../shared/storage';

export class SalesOrdersAccessStorageService {
  private storageService: SessionStorageServiceImpl<
    SalesOrdersAccessTableRow[]
  > = new SessionStorageServiceImpl();
  public get() {
    return (
      this.storageService.getItem(SALES_ORDERS_FOR_ACCESS_STORAGE_KEY) || []
    );
  }
  public save(selectedSalesOrders: SalesOrdersAccessTableRow[]) {
    return this.storageService.setItem(
      SALES_ORDERS_FOR_ACCESS_STORAGE_KEY,
      selectedSalesOrders
    );
  }
  public remove() {
    return this.storageService.removeItem(SALES_ORDERS_FOR_ACCESS_STORAGE_KEY);
  }
}
